/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectDataStatusChangeEvent { 
    /**
     * The status of the Business Object Data
     */
    status: string;
    /**
     * The timestamp of when the business object data status change occurred
     */
    eventTime: Date;
    /**
     * The User ID of the user who performed status update or registration of the Business Object Data
     */
    userId: string;
}
